import React from 'react';
import Email from '../common/input/Email';
import DataComponent from "../common/DataComponent";
import { Tooltip } from 'reactstrap';
import YesNoModal from "../common/YesNoComponent";
import { connect } from 'react-redux';
import { CHANGE_EMAIL_START, CHANGE_USERNAME, CHANGE_EMAIL_CLEAR_MESSAGE } from "../../constants/actionTypes";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from "../common/ConfirmationModal";

class EmailInfo extends DataComponent {
    constructor(props) {
        super(props);
        this.state = {
            fields: { newEmail: '', confirmedEmail: '' },
            showModal: false,
            modalText: null,
            modalYesFunction: null,
            modalNoFunction: null,
            inInputMode: false,
            submitEnabled: false,
            showToolTip: false,
            updateEmailOnly: false,
            isValid: { newEmail: false, confirmedEmail: false },
            isConfirmedEmailMatching: false
        };
        this.toggleInputMode = this.toggleInputMode.bind(this);
        this.inputsChanged = this.inputsChanged.bind(this);
        this.validateEmailInputs = this.validateEmailInputs.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEvents = this.handleEvents.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.cancelModal = this.cancelModal.bind(this);
    }

    onEditClick() {
        const { username, email } = this.props;
        if (username.trim() === email.trim()) {
            this.setState({
                showModal: true,
                modalText: "This email address is being used as your username. Are you sure you want to continue?",
                modalYesFunction: this.handleEvents,
                modalNoFunction: this.cancelModal
            });
        }
        else {
            this.setState({ updateEmailOnly: true });
            this.toggleInputMode(true);
        }
    }

    componentWillMount() {
        const { clearMessages } = this.props;
        if (clearMessages) {
            clearMessages();
        }
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.EmailInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    handleInputChange(e, valid) {
        const target = e.target;
        let { fields, isValid } = this.state;
        fields[target.name] = e.target.value;
        isValid[target.name] = valid;
        this.setState({ fields, isValid });
        if (valid) {
            this.inputsChanged();
        }
        window.componentChanged = true;
    }

    cancelModal() {
        this.setState({
            showModal: false
        });
    }

    validateEmailInputs() {
        const { newEmail, confirmedEmail } = this.state.fields;
        if (newEmail !== undefined && newEmail !== null && confirmedEmail !== undefined && confirmedEmail !== null) {
            if (confirmedEmail.toLowerCase() === newEmail.toLowerCase() && confirmedEmail.trim() !== "" && newEmail.trim() !== "")
                return true;
            else
                return false;
        }
        return false;
    }

    toggleInputMode(cancel) {
        this.setState(prevState => ({
            inInputMode: !prevState.inInputMode,
            isConfirmedEmailMatching: false
        }));
        if (cancel) {
            this.setState({
                fields: { newEmail: '', confirmedEmail: '' },
                isValid: { newEmail: false, confirmedEmail: false },
                submitEnabled: false
            });
        }
        const { clearMessages } = this.props;
        if (clearMessages) {
            clearMessages();
        }
    }

    inputsChanged() {
        const { submitEnabled, isConfirmedEmailMatching, isValid } = this.state;
        const bValid = this.validateEmailInputs();
        if (bValid && !submitEnabled) {
            this.setState({ submitEnabled: true, isConfirmedEmailMatching: true });
        }
        else if (!bValid && submitEnabled) {
            this.setState({ submitEnabled: false, isConfirmedEmailMatching: false });
        }
    }


    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    handleSubmit() {
        const { updateEmail, username, updateUserName, changeEmailError } = this.props;
        const { newEmail, confirmedEmail } = this.state.fields;
        const { updateEmailOnly } = this.state;
        if (updateEmailOnly) {
            updateEmail(username, newEmail, confirmedEmail);
        } else {
            updateEmail(username, newEmail, confirmedEmail);
            if (!changeEmailError)
                updateUserName(username, newEmail);
        }
        logUI("MBHWeb.Settings.ChangeEmail", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { inInputMode } = this.state;
        if (inInputMode) {
            if ((prevProps.email !== this.props.email) || (!prevProps.changeEmailSuccessMessage && this.props.changeEmailSuccessMessage)) {
                this.setState({ inInputMode: false });
            }
        }
    }

    handleEvents() {
        this.cancelModal();
        this.toggleInputMode(true);
        this.setState({ updateEmailOnly: false });
        window.componentChanged = false;
    }

    render() {
        const { email, changeEmailErrorText, changeEmailWaiting, changeEmailApiError, changeEmailSuccessMessage, isProxyUser } = this.props;
        const { inInputMode, submitEnabled, showToolTip, showModal, modalText, modalYesFunction, modalNoFunction, isConfirmedEmailMatching, isValid } = this.state;
        const { newEmail, confirmedEmail } = this.state.fields;
        if (isProxyUser) {
            return "";
        }
        return (<div className="row">
            <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />
            <div className="col-12 list-item-col not-linked">
                <div className="row align-items-end">
                    <div className="col-12 col-sm-6 col-md-3">
                        <div className="list-item-col__label">EMAIL <span className="icon-info" id='lbl-email' />
                            <Tooltip placement="top" isOpen={showToolTip} autohide={false} target="lbl-email" toggle={this.toggleTooltip}>
                                Used for prescription notifications and MyBSWHealth.
                            </Tooltip></div>
                    </div>
                    {changeEmailWaiting ?
                        <div className="spinner">
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                        </div> :

                        <div className="col-12 col-sm-6 text-left text-sm-right text-md-left">
                            {email ? <div className="list-item-col__info">{email}</div> : <div className="unable-display">Unable to display</div> }
                        </div>

                    }
                    <div className="col-12 col-md-3 text-sm-right">
                        <div className="list-item-col__action">{/* Edit should change to Save and Cancel when clicked */}
                            {inInputMode ?
                                <React.Fragment>
                                    {submitEnabled ?
                                        <div className="list-item-col__action--save" onClick={this.handleSubmit}>Save</div> :
                                        <div className="list-item-col__action--save disabled-style">Save</div>}
                                    <div className="list-item-col__action--cancel" onClick={() => this.toggleInputMode(true)}>Cancel</div>
                                </React.Fragment>
                                :
                                <div className="list-item-col__action--save" onClick={this.onEditClick}>Edit</div>
                            }
                        </div>
                    </div>
                </div>
                {/* Show this below the row above when user edits their email address */}
                {!inInputMode ? null :
                    <div className="row edit-mode">
                        <div className={"col-12 col-sm-6 form-group" + (isConfirmedEmailMatching ? " input-mismatch-password" : "") + ((!isConfirmedEmailMatching && isValid.newEmail && isValid.confirmedEmail) ? " input-mismatch" : "")}>
                            <Email placeholder="New Email Address" value={newEmail} name="newEmail" required
                                onChange={(e, isValid) => this.handleInputChange(e, isValid)}
                            />
                        </div>
                        <div className={"col-12 col-sm-6 form-group" + (isConfirmedEmailMatching ? " input-mismatch-password" : "") + (!isConfirmedEmailMatching && isValid.newEmail && isValid.confirmedEmail ? " input-mismatch" : "")}>
                            <Email placeholder="Confirm Email Address" value={confirmedEmail} name="confirmedEmail" required
                                onChange={(e, isValid) => this.handleInputChange(e, isValid)}
                            />
                            <span className="email-matches">
                                {isConfirmedEmailMatching && <>Email matches.</>}
                            </span>
                        </div>
                    </div>}
                {changeEmailErrorText && <div className="list-item-col__info">{changeEmailErrorText}</div>}
                <div className="row align-items-end">
                    <div className="col-12">
                        {changeEmailApiError && <SectionLoadingError message={changeEmailApiError} />}
                        {changeEmailSuccessMessage && <div className="success-msg">{changeEmailSuccessMessage}</div>}
                    </div>
                </div>
            </div>
            <ConfirmationModal when={inInputMode && (newEmail !== '' || confirmedEmail !== '')} callbackOnLeave={() => this.toggleInputMode(true)} />
        </div>);
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateEmail: (Username, NewEmail, ConfirmEmail) => {
            dispatch({
                type: CHANGE_EMAIL_START,
                Username,
                NewEmail,
                ConfirmEmail
            });
        },
        updateUserName: (OldUserName, NewUserName) => {
            dispatch({
                type: CHANGE_USERNAME,
                OldUserName: OldUserName,
                NewUserName: NewUserName
            });
        },
        clearMessages: () => {
            dispatch({
                type: CHANGE_EMAIL_CLEAR_MESSAGE
            });
        }
    };
};

const mapStateToProps = (state) => {
    return {
        email: state.domain.e,
        username: state.domain.un,
        changeEmailWaiting: state.header.changeEmailWaiting,
        changeEmailApiError: state.header.changeEmailError,
        changeEmailSuccessMessage: state.header.changeEmailSuccessMessage,
        changeEmailErrorText: state.header.changeEmailErrorText,
        isProxyUser: state.domain.ip

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailInfo);